export enum SfEventsTypes {
  individual = 'individual',
  corporate = 'corporate',
}
export enum SfCorporateEventResourceTypes {
  image = 'image',
  video = 'video',
  document = 'document',
}
